import * as React from "react";
import { useContext } from "react";
import styled from "@mui/material/styles/styled";
import { ACTION, CATEGORY, evt } from "fe-common/analytics/analytics";
import { useDiagnosticNavigation } from "../../useDiagnosticNavigation";
import { ActionButton } from "fe-common/ui/buttons/actionButton";
import StartOverIconSvg from "../../../../assets/startOverIcon.svg";
import { ClinicModeContext } from "../../../../context/diagnosticAgent";
//region [[ Styles ]]

const StartOverIconView = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface StartOverIconProps {
  onlyIcon?: boolean;
  className?: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const StartOverButton = ({ ...props }: StartOverIconProps) => {
  const { setStartOverDialogProps } = useDiagnosticNavigation();

  const openDialog = (event) => {
    event.stopPropagation();
    evt({
      category: CATEGORY.AGENT_WIZARD,
      action: ACTION.START_OVER_BUTTON_CLICKED,
    });
    setStartOverDialogProps({ open: true });
  };

  const clinicMode = useContext(ClinicModeContext);
  if (clinicMode) return null;

  return (
    <StartOverIconView>
      <ActionButton
        className={props.className}
        onClick={openDialog}
        label={"Start Over"}
        icon={<img src={StartOverIconSvg} alt={"Start Over"} />}
        iconOnly={props.onlyIcon}
      />
    </StartOverIconView>
  );
};
